import "./FieldReports.module.css";
import Header from "@/reusable_sections/Header";
import LatestUpdates from "./sections/LatestUpdates";
import JoinOurNewsletter from "./sections/JoinOurNewsletter";
import Footer from "@/reusable_sections/Footer";
export default function FieldReportsPage() {
  return <div>
      <Header />
      <LatestUpdates />
      <JoinOurNewsletter />
      <Footer />
    </div>;
}